export type IntakeValidationState = {
  name: string;
  description: string;
  strategicDriver: string;
  team: string;
  sponsor: string;
  productOwner: string;
  technicalOwner: string;
  targetQuarter: string;
  deadline: string;
  estimatedSprints: string;
};

export type IntakeTextField = keyof IntakeValidationState;

export function validateIntake(form: IntakeValidationState) {
  const errors: Partial<Record<IntakeTextField, string>> = {};
  const length = (
    key: IntakeTextField,
    name: string,
    min: number,
    max: number,
    optional = false,
  ) => {
    const value = form[key].trim();
    if (!value && optional) return;
    if (!value) errors[key] = `${name} is required.`;
    else if (value.length < min)
      errors[key] = `${name} must be at least ${min} characters.`;
    else if (value.length > max)
      errors[key] = `${name} must be ${max} characters or fewer.`;
  };
  length("name", "Initiative name", 3, 180);
  length("description", "Description", 10, 10_000);
  length("strategicDriver", "Strategic driver", 2, 120);
  length("team", "Submitting team", 2, 120);
  length("sponsor", "Executive sponsor", 2, 160);
  length("productOwner", "Product owner", 1, 160, true);
  length("technicalOwner", "Technical owner", 1, 160, true);
  length("targetQuarter", "Target quarter", 1, 40, true);
  length("deadline", "Deadline", 1, 80, true);
  if (form.estimatedSprints) {
    const value = Number(form.estimatedSprints);
    if (!Number.isInteger(value) || value < 0 || value > 520)
      errors.estimatedSprints =
        "Estimated sprints must be a whole number between 0 and 520.";
  }
  return errors;
}
